// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/supply_category.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/supply_category.proto.
 */
export const file_bfftypes_v1_supply_category: GenFile = /*@__PURE__*/
  fileDesc("CiFiZmZ0eXBlcy92MS9zdXBwbHlfY2F0ZWdvcnkucHJvdG8SC2JmZnR5cGVzLnYxKq0BCg5TdXBwbHlDYXRlZ29yeRIfChtTVVBQTFlfQ0FURUdPUllfVU5TUEVDSUZJRUQQABIdChlTVVBQTFlfQ0FURUdPUllfQklMQVRFUkFMEAESGgoWU1VQUExZX0NBVEVHT1JZX01BUktFVBACEiIKHlNVUFBMWV9DQVRFR09SWV9CQUNLVVBfUkVHVUxBUhADEhsKF1NVUFBMWV9DQVRFR09SWV9GVVRVUkVTEARCQlpAZ2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdHlwZXMvdjE7YmZmdHlwZXN2MWIGcHJvdG8z");

/**
 * SupplyCategory は供給力 48 点データのカテゴリ (取引区分) を表す。
 * Wire values mirror backend internalapi.v1.SupplyCategory 1:1。
 * Hosted under bfftypes/v1 so that BFF service packages can reuse the enum
 * without depending on backend internal types.
 *
 * @generated from enum bfftypes.v1.SupplyCategory
 */
export enum SupplyCategory {
  /**
   * @generated from enum value: SUPPLY_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPLY_CATEGORY_BILATERAL = 1;
   */
  BILATERAL = 1,

  /**
   * @generated from enum value: SUPPLY_CATEGORY_MARKET = 2;
   */
  MARKET = 2,

  /**
   * @generated from enum value: SUPPLY_CATEGORY_BACKUP_REGULAR = 3;
   */
  BACKUP_REGULAR = 3,

  /**
   * @generated from enum value: SUPPLY_CATEGORY_FUTURES = 4;
   */
  FUTURES = 4,
}

/**
 * Describes the enum bfftypes.v1.SupplyCategory.
 */
export const SupplyCategorySchema: GenEnum<SupplyCategory> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_supply_category, 0);

